import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudOff2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-off-2, offline "><path d="M7 19.25C4.10051 19.25 1.75 16.8995 1.75 14C1.75 11.3287 3.74507 9.12339 6.32647 8.7928C7.13793 6.44009 9.3716 4.75 12 4.75C12.7803 4.75 13.5259 4.89897 14.2098 5.17002M16.9636 7.37808C17.6177 8.33906 18 9.49988 18 10.75C18 10.8344 17.9983 10.9184 17.9948 11.002C18.038 11.0007 18.0814 11 18.125 11C20.4032 11 22.25 12.8468 22.25 15.125C22.25 17.4032 20.4032 19.25 18.125 19.25H10.6979M15.75 3.25L6.25 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCloudOff2;
